import React from "react";
import Helmet from "react-helmet";
import JobHeader from "../../components/JobHeader";
import JobContact from "../../components/JobContact";

function InspecteurScope12() {
    return (
        <React.Fragment>
            <Helmet>
                <title>Inspecteur Zonnepanelen, Laadpalen en Accu's - Vacature - Werken bij Smith</title>
                <meta name="description" content="Als Inspecteur Zonnepanelen, Laadpalen en Accu's ben je verantwoordelijk voor het uitvoeren van keuringen, inspecties en controles op installaties in zowel de particuliere als zakelijke markt. Je speelt een belangrijke rol in het waarborgen van veiligheid, kwaliteit en efficiëntie." />
            </Helmet>

            <JobHeader jobId="inspecteurScope12"/>

            <article className="container container-sm job-article">

                <div className="card mb-3">
                    <div className="card-body text-center">
                        <b className="text-tuinbouw ml-2 mr-2">
                            <i className="fas fa-location-dot"/> Maasdijk
                        </b>
                        <b className="text-solar ml-2 mr-2">
                            <i className="fas fa-clock"/> Werkweek van 40 uur
                        </b>
                        <b className="text-tuinbouw ml-2 mr-2">
                            <i className="fas fa-graduation-cap"/> MBO
                        </b>
                        <b className="text-solar ml-2 mr-2">
                            <i className="fas fa-building"/> Smith Solar B.V.
                        </b>
                    </div>
                </div>

                <h2>Over de functie</h2>
                <p>
                    Ben jij technisch onderlegd en heb je oog voor detail? Heb je affiniteit met duurzaamheid en hernieuwbare energie? 
                    Dan zijn wij op zoek naar jou! Als Inspecteur Zonnepanelen, Laadpalen en Accu's ben jij verantwoordelijk voor het 
                    uitvoeren van keuringen, inspecties en controles op installaties in zowel de particuliere als zakelijke markt. 
                    Je speelt een belangrijke rol in het waarborgen van veiligheid, kwaliteit en efficiëntie.
                </p>

                <h2>Wat ga je doen?</h2>
                <ul>
                    <li>Uitvoeren van (periodieke) inspecties volgens SCIOS Scope 12</li>
                    <li>Controleren van de technische staat, aansluiting en werking van zonnepanelen, laadpalen en energieopslagsystemen</li>
                    <li>Opstellen van inspectierapporten en adviseren over verbeteringen</li>
                    <li>Signaleren van risico's en veiligheidsissues</li>
                    <li>Ondersteunen bij keuringen voor oplevering of bij storingen</li>
                    <li>Klantgericht communiceren over bevindingen en aanbevelingen</li>
                </ul>

                <h2>Wat breng je mee?</h2>
                <ul>
                    <li>Afgeronde technische opleiding (minimaal mbo-niveau 4, richting elektrotechniek of vergelijkbaar)</li>
                    <li>Aantoonbare ervaring met PV-installaties, laadinfra en/of accu-opslagsystemen</li>
                    <li>Certificeringen als Scope 12 inspecteur</li>
                    <li>Rijbewijs B en bereidheid om te reizen binnen Nederland</li>
                    <li>Een kritische blik, nauwkeurigheid en een proactieve houding</li>
                </ul>

                <h2>Wat bieden wij jou?</h2>
                <ul>
                    <li>Marktconform salaris, afhankelijk van ervaring en certificeringen</li>
                    <li>Opleidings- en doorgroeimogelijkheden (zoals Scope-certificering)</li>
                    <li>Een afwisselende baan in een snelgroeiende sector</li>
                    <li>Laptop, telefoon en eventueel een auto van de zaak</li>
                    <li>Werken in een enthousiast en professioneel team met passie voor duurzaamheid</li>
                </ul>

                <h2>Is je interesse gewekt en wil je meer weten?</h2>
                <p>
                    Stuur dan je motivatie met CV naar Karel Smith
                    via <a href="mailto:hr@smithtechniek.nl">hr@smithtechniek.nl</a> of
                    bel <a href="tel:+31620967847">06 209 678 47</a>.
                </p>

                <JobContact jobId="inspecteurScope12"/>
            </article>
        </React.Fragment>
    );
}

export default React.memo(InspecteurScope12);
